import type { Country } from '../country';
import { genericPhoneNumber } from '@tectonics/commons/customer-form/generic-phone-number';
import { validateMalaysianPhone } from '@tectonics/prs/malaysia/validation/malaysian-phone';

export const MALAYSIA_PHONE_MASK = [
  '+', '6', '0', ' ',
  /0/, /1/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/,
];

const MALAYSIA: Country = {
  code: 'my',
  customerForm: {
    phoneNumber: {
      ...genericPhoneNumber,
      mask: MALAYSIA_PHONE_MASK,
      validationFunction: validateMalaysianPhone,
      inputFieldName: 'malaysiaPhoneNumber',
    },
  },
};

export default MALAYSIA;
